import { render, staticRenderFns } from "./CampaignStatus.vue?vue&type=template&id=52533a51&scoped=true&"
import script from "./CampaignStatus.vue?vue&type=script&lang=js&"
export * from "./CampaignStatus.vue?vue&type=script&lang=js&"
import style0 from "./CampaignStatus.vue?vue&type=style&index=0&id=52533a51&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52533a51",
  null
  
)

export default component.exports